import { Schema, normalize, arrayOf } from 'normalizr'
import { receiveComments } from '@actions/comment_actions.js'
import { receiveUsers } from '@actions/user_actions.js'
import { toastSuccess, toastError } from '@actions/toast_actions.js'

const BULK_CHANGE_VISIBILITY_ERROR_PREFIX = 'BCCV'

export function handleBulkChangeCommentsVisibilitySuccess(res, ids) {
  return (dispatch, getState) => {
    const responseData = res.data
    const {
      data: { comments, flash },
    } = responseData

    // now normalize the response
    // comments comes in as an array, so create an object that normalizr can deal with easily
    const normalizableObj = {
      comments,
    }
    const comment = new Schema('comments')
    const user = new Schema('users')
    comment.define({
      user,
    })
    const normalized = normalize(normalizableObj, {
      comments: arrayOf(comment),
      users: arrayOf(user),
    })

    // first put the users into state, then the comments
    dispatch(receiveUsers(normalized.entities.users))
    dispatch(receiveComments(normalized.entities.comments))
    dispatch(toastSuccess('Updated comments'))
  }
}

export function handleBulkChangeCommentsVisibilityError(error, ids) {
  return (dispatch, getState) => {
    const response = err.response
    dispatch(toastError(`Error updating comments: ${BULK_CHANGE_VISIBILITY_ERROR_PREFIX}-${response.status}`))
  }
}
